import { Grid, Paper } from "@mui/material";

export const SessionEnded = () => {
	//TODO Design à finaliser
	return (
		<Paper>
			<Grid container alignContent="center">
				<Grid item xs={6}>
					<h3>Vous avez été déconnecté</h3>
				</Grid>
			</Grid>
		</Paper>
	);
};
